import React from 'react';
import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';
import {
    ResponsiveSidebarDialog,
    ModalTitle,
    ModalContent,
    StickyModalActions,
    SecondaryButton,
    PrimaryButton,
} from '@/styles/blocks';
import { Body1 } from './blocks';

// Deleting a subregion also deletes its zips and carriers, so it asks first.
const DeleteSubregionModal = ({ subregion, onCancel, onDelete }) => (
    <ResponsiveSidebarDialog open={!!subregion} onClose={onCancel}>
        <ModalTitle title="Delete subregion?" onClose={onCancel} />
        <ModalContent width={420}>
            <Grid
                container
                css={css`
                    padding: 8px 0 24px;
                `}
            >
                <Body1>
                    {`${
                        subregion?.name || 'This subregion'
                    } and its zips and carriers will be deleted. This can't be undone.`}
                </Body1>
            </Grid>
        </ModalContent>
        <StickyModalActions>
            <Grid item>
                <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            </Grid>
            <Grid item>
                <PrimaryButton red onClick={onDelete}>
                    Delete Subregion
                </PrimaryButton>
            </Grid>
        </StickyModalActions>
    </ResponsiveSidebarDialog>
);

export default DeleteSubregionModal;
